/**
 * Plan progress helpers
 * - Keep all dates normalized to YYYY-MM-DD whenever possible.
 */

export function toIsoDay(input) {
  const s = String(input || '').trim();
  if (!s) return null;
  return s.split('T')[0] || null;
}

export function flattenPlannedWorkouts(planJson) {
  const weeks = planJson?.weeks;
  if (!Array.isArray(weeks)) return [];
  const out = [];
  for (const week of weeks) {
    const ws = Array.isArray(week?.workouts) ? week.workouts : [];
    for (const w of ws) {
      if (!w) continue;
      out.push({ ...w, week_number: week?.week_number });
    }
  }
  return out;
}

export function getPlanWorkoutsCompletion(planJson) {
  const workouts = flattenPlannedWorkouts(planJson);
  const sessions = workouts.filter((w) => {
    const date = toIsoDay(w?.date);
    if (!date) return false;
    return String(w?.type || '').toLowerCase() !== 'rest';
  });

  const total = sessions.length;
  const done = sessions.filter((w) => w?.completed === true).length;
  const pct = total > 0 ? Math.round((done / total) * 100) : 0;
  return { total, done, pct };
}

export function getPlanEndDateISO(planJson) {
  const workouts = flattenPlannedWorkouts(planJson);
  const dates = workouts
    .map((w) => toIsoDay(w?.date))
    .filter(Boolean)
    .sort();
  return dates.length ? dates[dates.length - 1] : null;
}

export function getLastPlannedWorkoutDateISO(planJson) {
  const workouts = flattenPlannedWorkouts(planJson);
  const dates = workouts
    .filter((w) => String(w?.type || '').toLowerCase() !== 'rest')
    .map((w) => toIsoDay(w?.date))
    .filter(Boolean)
    .sort();
  return dates.length ? dates[dates.length - 1] : null;
}

export function getPlanStartDateISO(planJson, startDateFromDb = null) {
  const dbStart = toIsoDay(startDateFromDb);
  if (dbStart) return dbStart;

  const workouts = flattenPlannedWorkouts(planJson);
  const dates = workouts
    .map((w) => toIsoDay(w?.date))
    .filter(Boolean)
    .sort();
  return dates[0] || null;
}

export function isPlanEnded(endDateISO, now = new Date()) {
  const end = toIsoDay(endDateISO);
  if (!end) return false;
  const today = toIsoDay(now?.toISOString?.());
  if (!today) return false;
  return String(end) < String(today);
}

export function isPlanClosedStatus(status) {
  const value = String(status || '').trim().toLowerCase();
  return value === 'completed' || value === 'stopped';
}

